import { render, staticRenderFns } from "./PersonInfo.vue?vue&type=template&id=386132dd&scoped=true&"
import script from "./PersonInfo.vue?vue&type=script&lang=js&"
export * from "./PersonInfo.vue?vue&type=script&lang=js&"
import style0 from "./PersonInfo.vue?vue&type=style&index=0&id=386132dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386132dd",
  null
  
)

export default component.exports